module.exports = __webpack_public_path__ + "static/media/seasonal_page_Q2_2026_high_impact_btn.e7b6ade9.png";